import { NAVY, NAVY_D, GOLD, G50, G100, G500, G700 } from '@/lib/colors';
import { crossAppHref } from '@/lib/nav';
import type { ProductDict, ProductSectionData } from './i18n';

export function Hero({ t }: { t: ProductDict }) {
  return (
    <section
      style={{
        padding: '70px 24px 50px',
        background: `linear-gradient(135deg, ${NAVY} 0%, ${NAVY_D} 100%)`,
        color: '#fff',
        textAlign: 'center',
      }}>
      <div style={{ maxWidth: 880, margin: '0 auto' }}>
        <h1
          style={{
            fontFamily: 'Prompt',
            fontSize: 'clamp(32px, 5vw, 48px)',
            fontWeight: 700,
            lineHeight: 1.2,
            marginBottom: 18,
          }}>
          {t.hero_title}
        </h1>
        <p
          style={{
            fontSize: 16,
            color: 'rgba(255,255,255,0.75)',
            lineHeight: 1.7,
            maxWidth: 680,
            margin: '0 auto 28px',
          }}>
          {t.hero_sub}
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          <a
            href={crossAppHref('/signup')}
            style={{
              background: GOLD,
              color: '#fff',
              padding: '12px 26px',
              borderRadius: 8,
              fontFamily: 'Sarabun',
              fontSize: 15,
              fontWeight: 600,
              textDecoration: 'none',
            }}>
            {t.cta_signup}
          </a>
        </div>
      </div>
    </section>
  );
}

export function ProductSection({ s, even }: { s: ProductSectionData; even: boolean }) {
  return (
    <section id={s.id} style={{ padding: '72px 24px', background: even ? G50 : '#fff' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <div
          style={{
            fontFamily: 'Sarabun',
            fontSize: 12,
            fontWeight: 600,
            color: GOLD,
            textTransform: 'uppercase',
            letterSpacing: '0.1em',
            marginBottom: 8,
          }}>
          {s.kicker}
        </div>
        <h2
          style={{
            fontFamily: 'Prompt',
            fontSize: 'clamp(24px, 3.5vw, 32px)',
            fontWeight: 700,
            color: NAVY,
            marginBottom: 14,
            lineHeight: 1.3,
          }}>
          {s.title}
        </h2>
        <p style={{ fontSize: 15, color: G500, lineHeight: 1.7, maxWidth: 780, marginBottom: 36 }}>
          {s.sub}
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 16 }}>
          {s.items.map(([title, desc], i) => (
            <article
              key={i}
              style={{
                background: '#fff',
                borderRadius: 10,
                padding: 20,
                border: `1px solid ${G100}`,
                boxShadow: even ? '0 2px 8px rgba(27,43,94,0.05)' : 'none',
              }}>
              <h3
                style={{
                  fontFamily: 'Prompt',
                  fontSize: 15,
                  fontWeight: 700,
                  color: NAVY,
                  marginBottom: 8,
                  display: 'flex',
                  gap: 8,
                }}>
                <span style={{ color: GOLD }}>✓</span>
                {title}
              </h3>
              <p style={{ fontSize: 13, color: G700, lineHeight: 1.6 }}>{desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
